import { render, staticRenderFns } from "./QuizStudentQuizDetail.vue?vue&type=template&id=0b1ac942&"
import script from "./QuizStudentQuizDetail.vue?vue&type=script&lang=js&"
export * from "./QuizStudentQuizDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports